<template>
  <div class="main">
    <div
      class="main__others"
      v-if="otherData.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in otherData"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span class="value">{{item.value}}</span>
        </li>
      </ul>
    </div>
    <div
      class="main__others"
      v-if="batteryList.length>0"
    >
      <ul>
        <li
          style="width:20%"
          :title="'电芯'+`${index+1}`+'电压:'+item+'V'"
          v-for="(item, index) in batteryList"
          :key="index"
        >
          <span class="title">电芯{{index + 1}}电压: </span>
          <span class="value">{{item}}V</span>
        </li>
      </ul>
    </div>
    <div
      class="main__others"
      v-if="tempList.length>0"
    >
      <ul>
        <li
          style="width:20%"
          :title="'电芯'+`${index+1}`+'温度:'+item+'℃'"
          v-for="(item, index) in tempList"
          :key="index"
        >
          <span class="title">电芯{{index+1}}温度: </span>
          <span class="value">{{item}}℃</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      otherData: [
        { title: "协议厂商", value: "--" },
        { title: "出厂日期", value: "--" },

        { title: "低容量报警值", value: "--" },
        { title: "均衡板温度", value: "--" },
        { title: "均衡启控电压", value: "--" },
        { title: "均衡电流百分比", value: "--" },
        { title: "均衡精度", value: "--" },
        { title: "均衡开关", value: "--" },
        { title: "均衡温度保护值", value: "--" },
        { title: "均衡温度恢复值", value: "--" },
        { title: "电池地址", value: "--" },
        { title: "电池容量设置", value: "--" },

        { title: "总电池个数", value: "--" },
        { title: "电池温度保护值", value: "--" },
        { title: "电池温度恢复值", value: "--" },
        { title: "BMS校准的电池容量	", value: "--" },
        { title: "充电电流保护值", value: "--" },
        { title: "充电MOS开关", value: "--" },
        { title: "充电恢复电压", value: "--" },
        { title: "充电失效保护电压", value: "--" },
        { title: "充电保护电压", value: "--" },
        { title: "低温保护值", value: "--" },

        { title: "低温保护恢复值", value: "--" },
        { title: "放电恢复电压", value: "--" },
        { title: "放电失效保护电压", value: "--" },
        { title: "放电保护电压", value: "--" },
        { title: "放电峰值保护值", value: "--" },
        { title: "放电MOS开关", value: "--" },
        { title: "放电过流延时", value: "--" },
        { title: "放电过流保护值", value: "--" },
        { title: "机器编码", value: "--" },
        { title: "剩余容量", value: "--" },

        { title: "电池组个数", value: "--" },
        { title: "电流", value: "--" },
        { title: "总电压", value: "--" },
        { title: "功率板温度保护值", value: "--" },
        { title: "功率板温度保护值", value: "--" },
        { title: "功率板温度恢复值", value: "--" },
        { title: "循环使用次数", value: "--" },
        { title: "专用充电器开关", value: "--" },
        { title: "温度个数", value: "--" },
        { title: "总放电容量", value: "--" }
      ],
      batteryList: [],
      tempList: []
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        const {
          COMPANY,
          DateOfProduction,
          LowCapacityAlarm,
          balancedBoardTemp,
          balancedControlVoltage,
          balencedCurrentPercent,
          balencedPrecision,
          balencedSwitch,
          balencedTempProtection,
          balencedTempRecovery,
          batteryAddress,
          batteryCapacitySeting,
          batteryList,
          batteryNum,
          batteryTemperatureProtection,
          batteryTemperatureRecovery,
          calibrationCopacity,
          chargeCurrentProtection,
          chargeMosSwitch,
          chargeRecoveryVoltage,
          chargingFailureProtectionVoltage,
          chargingProtectionVoltage,
          cryogenicProtection,
          cryogenicRecovery,
          disChargeRecoveryVoltage,
          disChargingFailureProtectionVoltage,
          disChargingProtectionVoltage,
          dischargeMaxProtection,
          dischargeMosSwitch,
          dischargeOvercurrentDelay,
          dischargeOvercurrentProtection,
          machineCode,
          pileCopacity,
          pileCount,
          pileElectric,
          pileVoltage,
          powerBoardTemp,
          powerBoardTempProtection,
          powerBoardTempRecovery,
          recyclingNum,
          specialChargerSwitch,
          tempCount,
          tempList,
          totalDischargeCapacity
        } = val;
        this.otherData = [
          { title: "协议厂商", value: this.dataUnit(COMPANY) },
          { title: "出厂日期", value: this.dataUnit(DateOfProduction) },

          {
            title: "低容量报警值",
            value: this.dataUnit(LowCapacityAlarm, "%")
          },
          { title: "均衡板温度", value: this.dataUnit(balancedBoardTemp, "℃") },
          {
            title: "均衡启控电压",
            value: this.dataUnit(balancedControlVoltage, "mv")
          },
          {
            title: "均衡电流百分比",
            value: this.dataUnit(balencedCurrentPercent, "%")
          },
          { title: "均衡精度", value: this.dataUnit(balencedPrecision, "mv") },
          {
            title: "均衡开关",
            value:
              balencedSwitch === 0 ? "关" : balencedSwitch === 1 ? "开" : "--"
          },
          {
            title: "均衡温度保护值",
            value: this.dataUnit(balencedTempProtection, "℃")
          },
          {
            title: "均衡温度恢复值",
            value: this.dataUnit(balencedTempRecovery, "℃")
          },
          { title: "电池地址", value: this.dataUnit(batteryAddress) },
          {
            title: "电池容量设置",
            value: this.dataUnit(batteryCapacitySeting)
          },

          { title: "总电池个数", value: this.dataUnit(batteryNum) },
          {
            title: "电池温度保护值",
            value: this.dataUnit(batteryTemperatureProtection, "℃")
          },
          {
            title: "电池温度恢复值",
            value: this.dataUnit(batteryTemperatureRecovery, "℃")
          },
          {
            title: "BMS校准的电池容量",
            value: this.dataUnit(calibrationCopacity, "A·H")
          },
          {
            title: "充电电流保护值",
            value: this.dataUnit(chargeCurrentProtection, "A")
          },
          {
            title: "充电MOS开关",
            value:
              chargeMosSwitch === 0 ? "关" : chargeMosSwitch === 1 ? "开" : "--"
          },
          {
            title: "充电恢复电压",
            value: this.dataUnit(chargeRecoveryVoltage, "mv")
          },
          {
            title: "充电失效保护电压",
            value: this.dataUnit(chargingFailureProtectionVoltage, "mv")
          },
          {
            title: "充电保护电压",
            value: this.dataUnit(chargingProtectionVoltage, "mv")
          },
          {
            title: "低温保护值",
            value: this.dataUnit(cryogenicProtection, "℃")
          },

          {
            title: "低温保护恢复值",
            value: this.dataUnit(cryogenicRecovery, "℃")
          },
          {
            title: "放电恢复电压 ",
            value: this.dataUnit(disChargeRecoveryVoltage, "mv")
          },
          {
            title: "放电失效保护电压",
            value: this.dataUnit(disChargingFailureProtectionVoltage, "mv")
          },
          {
            title: "放电保护电压",
            value: this.dataUnit(disChargingProtectionVoltage, "mv")
          },
          {
            title: "放电峰值保护值",
            value: this.dataUnit(dischargeMaxProtection, "A")
          },
          {
            title: "放电MOS开关",
            value:
              dischargeMosSwitch === 0
                ? "关"
                : dischargeMosSwitch === 1
                ? "开"
                : "--"
          },
          {
            title: "放电过流延时",
            value: this.dataUnit(dischargeOvercurrentDelay, "秒")
          },
          {
            title: "放电过流保护值",
            value: this.dataUnit(dischargeOvercurrentProtection, "A")
          },
          { title: "机器编码", value: this.dataUnit(machineCode) },
          { title: "剩余容量", value: this.dataUnit(pileCopacity) },

          { title: "电池组个数", value: this.dataUnit(pileCount) },
          { title: "电流", value: this.dataUnit(pileElectric, "A") },
          { title: "总电压", value: this.dataUnit(pileVoltage, "V") },
          {
            title: "功率板温度",
            value: this.dataUnit(powerBoardTemp, "℃")
          },
          {
            title: "功率板温度保护值",
            value: this.dataUnit(powerBoardTempProtection, "℃")
          },
          {
            title: "功率板温度恢复值",
            value: this.dataUnit(powerBoardTempRecovery, "℃")
          },
          { title: "循环使用次数", value: this.dataUnit(recyclingNum) },
          {
            title: "专用充电器开关",
            value:
              specialChargerSwitch === 0
                ? "关"
                : specialChargerSwitch === 1
                ? "开"
                : "--"
          },
          { title: "温度个数", value: this.dataUnit(tempCount) },
          { title: "总放电容量", value: this.dataUnit(totalDischargeCapacity) }
        ];
        this.batteryList = batteryList || [];
        this.tempList = tempList || [];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    dataUnit(data, unit) {
      if (data != undefined && data != null && unit) {
        data = data + unit;
        return data;
      }else if (data === "" || data === undefined || data === null) {
        return "--";
      }
      return data;
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  &__others {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>